module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-regal-01.03cfef5c.jpeg";